export const DeleteSampleFromReplacementOrder = "9d8e7b881bc113cd6d7f26be47abd52204887b24be91f87fa2376cc7b11d23a7";